import { computed, observable, makeAutoObservable } from 'mobx';
import { MobxMapAutoNew } from 'src_common/common/mobx-utils/MobxMapAutoNew';
import { CasinoBannersDataState } from 'src/AppState/CmsState/CasinoBannersDataState/CasinoBannersData.state';
import { CollectionType } from 'src/domains/casino/models/models';
import { Session } from 'src_common/sdk/session';

export class CasinoBannersState {
    private readonly casinoBannersStateMap: MobxMapAutoNew<CollectionType, CasinoBannersDataState>;

    @observable public collection: CollectionType;

    public constructor(private readonly session: Session) {
        this.collection = 'casino';

        this.casinoBannersStateMap = new MobxMapAutoNew(
            (collection: CollectionType): CasinoBannersDataState => new CasinoBannersDataState(collection, this.session)
        );
        makeAutoObservable(this);
    }

    @computed public get casinoBannersData(): CasinoBannersDataState {
        return this.casinoBannersStateMap.get(this.collection);
    }

    public onChangeCollection = (collection: CollectionType): void => {
        this.collection = collection;
    };
}
